module.exports = __webpack_public_path__ + "static/cheap-180553cb391350fd66ff371663d862c0.woff";